import { render, staticRenderFns } from "./study-participant-edc-unscheduled-packets.vue?vue&type=template&id=c8131e70&scoped=true&"
import script from "./study-participant-edc-unscheduled-packets.vue?vue&type=script&lang=js&"
export * from "./study-participant-edc-unscheduled-packets.vue?vue&type=script&lang=js&"
import style0 from "./study-participant-edc-unscheduled-packets.vue?vue&type=style&index=0&id=c8131e70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8131e70",
  null
  
)

component.options.__file = "study-participant-edc-unscheduled-packets.vue"
export default component.exports